import React, { Component } from 'react';
import {
    Typography,
    Box,
    withStyles
} from '@material-ui/core';

const styles = theme => ({
    sectionBody: {
        padding: '1rem',
    },
    bodyText: {
        fontSize: '1rem',
        fontWeight: 400,
        color: '#495057',
        marginBottom: '1rem',
    },
    label: {
        fontSize: '1rem',
        fontWeight: 600,
        color: '#495057',
        marginRight: '0.5rem',
    },
});

class RespondClienteSection extends Component {
    formatarData = (data) => {
        if (!data) return '-';
        const { currentLanguage } = this.props;
        const locale = currentLanguage?.lang_code === 'en' ? 'en-US' : (currentLanguage?.lang_code === 'es' ? 'es-ES' : 'pt-BR');
        return new Date(data).toLocaleDateString(locale);
    };

    render() {
        const { classes, cliente, currentLanguage } = this.props;

        if (!cliente) {
            return (
                <Typography className={classes.bodyText}>
                    {currentLanguage.bepiService.shared.shared_resp_no_client_msg}
                </Typography>
            );
        }

        return (
            <Box className={classes.sectionBody}>
                <Typography className={classes.bodyText}>
                    <span className={classes.label}>{currentLanguage.bepiService.shared.shared_resp_client_company}:</span>
                    {cliente.empresa || '-'}
                </Typography>
                <Typography className={classes.bodyText}>
                    <span className={classes.label}>{currentLanguage.bepiService.shared.shared_resp_client_name}:</span>
                    {cliente.nome || '-'}
                </Typography>
                <Typography className={classes.bodyText}>
                    <span className={classes.label}>{currentLanguage.bepiService.shared.shared_resp_client_phone}:</span>
                    {cliente.telefone || '-'}
                </Typography>
                <Typography className={classes.bodyText}>
                    <span className={classes.label}>{currentLanguage.bepiService.shared.shared_resp_client_cnpj}:</span>
                    {cliente.cnpj || '-'}
                </Typography>
                <Typography className={classes.bodyText}>
                    <span className={classes.label}>{currentLanguage.bepiService.shared.shared_resp_client_date}:</span>
                    {this.formatarData(cliente.dt_criacao)}
                </Typography>
                <Typography className={classes.bodyText}>
                    <span className={classes.label}>{currentLanguage.bepiService.shared.shared_resp_client_email}:</span>
                    {cliente.email || '-'}
                </Typography>
            </Box>
        );
    }
}

export default withStyles(styles)(RespondClienteSection);
